import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#44403C] text-[#EBE5DE] py-12" data-id="element-67">
        <div className="container mx-auto px-4 text-center" data-id="element-68">
          <p className="mb-4 font-medium" data-id="element-69">Rutina Low-Tox Anti-Alergias</p>
          <p className="text-sm opacity-60 max-w-md mx-auto mb-8" data-id="element-70">
            Este producto no sustituye el consejo médico profesional. Siempre
            consulta con tu pediatra ante síntomas graves.
          </p>

          {/* Links */}
          <div className="flex justify-center gap-6 mb-8" data-id="element-71">
            <button onClick={() => setShowPrivacy(true)} className="text-sm hover:text-[#C97D60] transition-colors underline" data-id="element-72">
              Política de Privacidad
            </button>
            <button onClick={() => setShowTerms(true)} className="text-sm hover:text-[#C97D60] transition-colors underline" data-id="element-73">
              Términos y Condiciones
            </button>
          </div>

          <div className="text-xs opacity-40" data-id="element-74">
            &copy; {new Date().getFullYear()} Low-Tox Mama. Todos los derechos
            reservados.
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-75">
        <div className="prose prose-sm max-w-none text-[#57534E]" data-id="element-76">
          <p className="mb-4" data-id="element-77">
            <strong data-id="element-78">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-79">
            1. Información que Recopilamos
          </h3>
          <p className="mb-4" data-id="element-80">
            Cuando compras nuestro ebook "Rutina Low-Tox Anti-Alergias",
            recopilamos información básica necesaria para procesar tu compra y
            entregarte el producto digital:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-81">
            <li data-id="element-82">Nombre y dirección de correo electrónico</li>
            <li data-id="element-83">
              Información de pago (procesada de forma segura por nuestro
              proveedor de pagos)
            </li>
            <li data-id="element-84">Dirección IP y datos de navegación para prevenir fraude</li>
          </ul>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-85">
            2. Uso de la Información
          </h3>
          <p className="mb-4" data-id="element-86">Utilizamos tu información únicamente para:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-87">
            <li data-id="element-88">Procesar y completar tu compra</li>
            <li data-id="element-89">Enviarte el ebook y materiales relacionados</li>
            <li data-id="element-90">Proporcionar soporte al cliente si lo necesitas</li>
            <li data-id="element-91">
              Enviar actualizaciones importantes sobre el producto (solo si das
              tu consentimiento)
            </li>
          </ul>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-92">
            3. Protección de Datos
          </h3>
          <p className="mb-4" data-id="element-93">
            Implementamos medidas de seguridad para proteger tu información
            personal. No vendemos, alquilamos ni compartimos tu información con
            terceros, excepto cuando sea necesario para procesar tu pago o
            cumplir con la ley.
          </p>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-94">
            4. Cookies
          </h3>
          <p className="mb-4" data-id="element-95">
            Utilizamos cookies esenciales para el funcionamiento del sitio web y
            para mejorar tu experiencia de compra. Puedes configurar tu
            navegador para rechazar cookies, aunque esto puede afectar algunas
            funcionalidades.
          </p>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-96">
            5. Tus Derechos
          </h3>
          <p className="mb-4" data-id="element-97">Tienes derecho a:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-98">
            <li data-id="element-99">Acceder a tu información personal</li>
            <li data-id="element-100">Solicitar corrección de datos incorrectos</li>
            <li data-id="element-101">
              Solicitar eliminación de tus datos (sujeto a obligaciones legales)
            </li>
            <li data-id="element-102">Retirar tu consentimiento para comunicaciones de marketing</li>
          </ul>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-103">
            6. Cambios a esta Política
          </h3>
          <p className="mb-4" data-id="element-104">
            Podemos actualizar esta política ocasionalmente. Te notificaremos de
            cambios significativos por correo electrónico o mediante un aviso en
            nuestro sitio web.
          </p>

          <p className="mt-6 text-sm italic" data-id="element-105">
            Si tienes preguntas sobre nuestra política de privacidad, por favor
            contáctanos a través de nuestro correo electrónico de soporte.
          </p>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-106">
        <div className="prose prose-sm max-w-none text-[#57534E]" data-id="element-107">
          <p className="mb-4" data-id="element-108">
            <strong data-id="element-109">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-110">
            1. Aceptación de Términos
          </h3>
          <p className="mb-4" data-id="element-111">
            Al comprar y descargar "Rutina Low-Tox Anti-Alergias", aceptas estos
            términos y condiciones. Si no estás de acuerdo, por favor no
            realices la compra.
          </p>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-112">
            2. Descripción del Producto
          </h3>
          <p className="mb-4" data-id="element-113">
            El ebook "Rutina Low-Tox Anti-Alergias" es un producto digital que
            incluye:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-114">
            <li data-id="element-115">
              Guía completa en formato PDF con recetas low-tox organizadas por
              zonas
            </li>
            <li data-id="element-116">Lista de compras Rutina Low-Tox</li>
            <li data-id="element-117">Guía de Brotes (protocolo de 48 horas)</li>
          </ul>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-118">
            3. Descargo de Responsabilidad Médica
          </h3>
          <p className="mb-4 font-semibold text-[#C97D60]" data-id="element-119">
            IMPORTANTE: Este producto es únicamente informativo y educativo.
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-120">
            <li data-id="element-121">
              No sustituye el consejo, diagnóstico o tratamiento médico
              profesional
            </li>
            <li data-id="element-122">
              Siempre consulta con tu pediatra o médico ante síntomas graves o
              persistentes
            </li>
            <li data-id="element-123">No garantizamos resultados específicos ni cura de alergias</li>
            <li data-id="element-124">
              Cada niño es diferente y puede reaccionar de manera distinta
            </li>
          </ul>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-125">
            4. Uso del Contenido
          </h3>
          <p className="mb-4" data-id="element-126">
            Al comprar este ebook, obtienes una licencia de uso personal que te
            permite:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-127">
            <li data-id="element-128">Descargar y usar el contenido para tu uso personal</li>
            <li data-id="element-129">Imprimir copias para tu hogar</li>
          </ul>
          <p className="mb-4" data-id="element-130">
            <strong data-id="element-131">NO está permitido:</strong>
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-132">
            <li data-id="element-133">Compartir, revender o distribuir el ebook</li>
            <li data-id="element-134">Reproducir el contenido con fines comerciales</li>
            <li data-id="element-135">Modificar o crear obras derivadas sin autorización</li>
          </ul>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-136">
            5. Política de Reembolso
          </h3>
          <p className="mb-4" data-id="element-137">
            Debido a la naturaleza digital del producto, todas las ventas son
            finales. No ofrecemos reembolsos una vez que el ebook ha sido
            descargado o el acceso ha sido proporcionado.
          </p>
          <p className="mb-4" data-id="element-138">
            Excepción: Si experimentas problemas técnicos que te impiden acceder
            al producto, contáctanos dentro de las 48 horas posteriores a la
            compra para recibir asistencia.
          </p>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-139">
            6. Propiedad Intelectual
          </h3>
          <p className="mb-4" data-id="element-140">
            Todo el contenido del ebook, incluyendo texto, imágenes, diseño y
            recetas, está protegido por derechos de autor y es propiedad
            exclusiva de Low-Tox Mama.
          </p>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-141">
            7. Limitación de Responsabilidad
          </h3>
          <p className="mb-4" data-id="element-142">No nos hacemos responsables de:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-143">
            <li data-id="element-144">
              Reacciones alérgicas o efectos adversos derivados del uso de las
              recetas
            </li>
            <li data-id="element-145">
              Daños a propiedades o superficies por uso inadecuado de los
              productos
            </li>
            <li data-id="element-146">Resultados no obtenidos o expectativas no cumplidas</li>
          </ul>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-147">
            8. Modificaciones
          </h3>
          <p className="mb-4" data-id="element-148">
            Nos reservamos el derecho de actualizar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación.
          </p>

          <h3 className="text-lg font-bold text-[#44403C] mt-6 mb-3" data-id="element-149">
            9. Jurisdicción
          </h3>
          <p className="mb-4" data-id="element-150">
            Estos términos se rigen por las leyes de Estados Unidos. Cualquier
            disputa será resuelta en los tribunales competentes de la
            jurisdicción correspondiente.
          </p>

          <p className="mt-6 text-sm italic" data-id="element-151">
            Al completar tu compra, confirmas que has leído, entendido y
            aceptado estos términos y condiciones.
          </p>
        </div>
      </Modal>
    </>;
}